import { configureStore } from '@reduxjs/toolkit'
import {
    profileReducer, subscriptionReducer,
    userReducer
} from './reducers/userReducer'
import { courseReducer } from './reducers/courseReducer'
import { adminReducer } from './reducers/adminReducer'
import { otherReducer } from './reducers/otherReducer'


export const server = 'https://e-learning-backend-lx1x.vercel.app'
// export const server = 'http://localhost:4000'

const store = configureStore({
    reducer: {
        user: userReducer,
        profile: profileReducer,
        course: courseReducer,
        subscription: subscriptionReducer,
        admin: adminReducer,
        other: otherReducer,
    }
})

export default store